import { render, staticRenderFns } from "./ConnectRecord.vue?vue&type=template&id=1bc1c4a9"
import script from "./ConnectRecord.vue?vue&type=script&lang=js"
export * from "./ConnectRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports